export const GEO_URL = "https://get.geojs.io/v1/ip/geo.json";
export const DEFAULT_ZOOM = 14;
export const MIN_ZOOM = 5;
export const DEFAULT_CENTER = { lat: 0, lng: 0 };
export const DEFAULT_AREA_RADIUS = 1500;
export const MIN_TOUR_DISTANCE = 1000;
export const MAX_TOUR_DISTANCE = 5000;
/* https://en.wikipedia.org/wiki/Mercator_projection#Formulae_for_distance */
export const MAX_LAT_DISTANCE = 20037508.34;
